const state = {
  organization: {}
}
const mutations = {
  'SET_ORGANIZATION' (state, payload) {
    state.organization = payload
    localStorage.setItem('organization', JSON.stringify(state.organization))
  }
}

const actions = {
  setOrganization ({ commit } , payload) {
    commit('SET_ORGANIZATION', payload)
  }
}

const getters = {
  getOrganization: state => JSON.parse(localStorage.getItem('organization'))
}

export default {
  state,
  mutations,
  actions,
  getters
}
